// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1ZgGU","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__5xDy4"};